import { supabase } from '../lib/supabase';

export interface Ambassador {
  id: string;
  name: string;
  avatar_url: string;
  order_index: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export const loadAmbassadors = async (): Promise<Ambassador[]> => {
  try {
    const { data, error } = await supabase
      .from('ambassadors')
      .select('*')
      .eq('is_active', true)
      .order('order_index', { ascending: true });
    if (error) throw error;
    return (data as Ambassador[]) || [];
  } catch (error) {
    console.error('Erro ao carregar ambassadors:', error);
    return [];
  }
};

export const updateAmbassador = async (
  id: string,
  updates: Partial<Ambassador>
): Promise<Ambassador | null> => {
  try {
    const { data, error } = await supabase
      .from('ambassadors')
      .update({ ...updates, updated_at: new Date().toISOString() })
      .eq('id', id)
      .select()
      .single();
    if (error) throw error;
    return data as Ambassador;
  } catch (error) {
    console.error('Erro ao atualizar ambassador:', error);
    return null;
  }
};

export const createAmbassador = async (
  payload: Omit<Ambassador, 'id' | 'created_at' | 'updated_at'>
): Promise<Ambassador | null> => {
  try {
    const { data, error } = await supabase
      .from('ambassadors')
      .insert(payload)
      .select()
      .single();
    if (error) throw error;
    return data as Ambassador;
  } catch (error) {
    console.error('Erro ao criar ambassador:', error);
    return null;
  }
};


